import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  mobileRecharge: "",
  dthRecharge: "",
};

const mobileRechargeStart = (state) => {
  return {
    ...state,
    isLoading: true,
    mobileRecharge: "",
    error: "",
  };
};

const mobileRechargeSuccess = (state, data) => {
  return {
    ...state,
    mobileRecharge: data,
    isLoading: false,
    error: "",
  };
};

const mobileRechargeFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const dthRechargeStart = (state) => {
  return {
    ...state,
    isLoading: true,
    dthRecharge: "",
    error: "",
  };
};

const dthRechargeSuccess = (state, data) => {
  return {
    ...state,
    dthRecharge: data,
    isLoading: false,
    error: "",
  };
};

const dthRechargeFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//reset Aeps func

const resetRechargeFunc = (state) => {
  return {
    ...state,
    isLoading: false,
    error: "",
    dthRecharge: "",
    mobileRecharge: "",
  };
};

const RechargeReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.RECHARGE_MOBILE_START:
      return mobileRechargeStart(state);
    case actionTypes.RECHARGE_MOBILE_SUCCESS:
      return mobileRechargeSuccess(state, action.data);
    case actionTypes.RECHARGE_MOBILE_FAIL:
      return mobileRechargeFail(state, action.err);

    case actionTypes.RECHARGE_DTH_START:
      return dthRechargeStart(state);
    case actionTypes.RECHARGE_DTH_SUCCESS:
      return dthRechargeSuccess(state, action.data);
    case actionTypes.RECHARGE_DTH_FAIL:
      return dthRechargeFail(state, action.err);

    case actionTypes.RESET_RECHARGE_START:
      return resetRechargeFunc(state);

    default:
      return state;
  }
};

export default RechargeReducer;
